export const getModalType = state => state.modalReducer.type;
export const getModalProps = state => state.modalReducer.props;
